import { render, staticRenderFns } from "./ClientsHeaders.vue?vue&type=template&id=425cce4c&scoped=true&"
import script from "./ClientsHeaders.vue?vue&type=script&lang=js&"
export * from "./ClientsHeaders.vue?vue&type=script&lang=js&"
import style0 from "./ClientsHeaders.vue?vue&type=style&index=0&id=425cce4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425cce4c",
  null
  
)

export default component.exports